var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m23.122 9.254-.72-.758-13.524 14.25.72.758 1.017-1.072h10.472a1.019 1.073 0 0 0 1.017-1.072V10.326ZM21.087 21.36h-9.455l3.965-4.177 1.21 1.275a1.017 1.072 0 0 0 1.438 0l.807-.85 2.035 2.142zm0-3.126-1.315-1.386a1.017 1.072 0 0 0-1.44 0l-.806.85-1.21-1.274 4.77-5.026zM10.913 19.216v-1.608l2.544-2.678.698.736.72-.759-.7-.737a1.017 1.072 0 0 0-1.438 0l-1.824 1.922V10.64h8.14V9.568h-8.14a1.018 1.073 0 0 0-1.017 1.072v8.576z",
    style: {
      fill: "#ccc",
      strokeWidth: 0.522162
    },
    transform: "matrix(.69939 0 0 .66865 4.694 5.173)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<Transparent Rectangle>",
    style: {
      strokeWidth: 0.522162,
      fill: "none"
    },
    d: "M7.861 7.424h16.278v17.152H7.861z",
    transform: "matrix(.69939 0 0 .66865 4.694 5.173)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.c8834c0e62a63c5adc539ff979641aad.svg";
export { ForwardRef as ReactComponent };